import {
  createAction,
  createActionGroup,
  emptyProps,
  props,
} from '@ngrx/store';
import { PromoCode } from '@fantaz/shared/data-access/models';

// ============================================================================
// Save Promo Code Actions
// ============================================================================
export const savePromoCode = createAction(
  '[SavePromoCode] Save',
  props<{ promoCode: string }>(),
);

export const savePromoCodeSuccess = createAction(
  '[SavePromoCode/API] Save PromoCode Success',
  props<{ promoCode: string }>(),
);

export const savePromoCodeFailure = createAction(
  '[SavePromoCode/API] Save PromoCode Failure',
  props<{ error: Error; promoCode: string }>(),
);

// ============================================================================
// Remove Promo Code Actions
// ============================================================================

export const removePromoCode = createAction(
  '[RemovePromoCode] Remove',
  props<{ options?: { force?: boolean } }>(),
);

export const removePromoCodeSuccess = createAction(
  '[RemovePromoCode/API] Remove PromoCode Success',
);

export const removePromoCodeFailure = createAction(
  '[RemovePromoCode/API] Remove PromoCode Failure',
  props<{ error: Error }>(),
);

// ============================================================================
// Load Promo Code Actions
// ============================================================================
export const loadPromoCode = createAction('[PromoCode] Load PromoCode');

export const loadPromoCodeSuccess = createAction(
  '[PromoCode/API] Load PromoCode Success',
  props<{ promoCode: string | null | undefined }>(),
);

export const loadPromoCodeFailure = createAction(
  '[PromoCode/API] Load PromoCode Failure',
  props<{ error: Error }>(),
);

// ============================================================================
// Apply Promo Code Actions
// ============================================================================

export const applyPromoCodeInit = createAction('[ApplyPromoCode] Init');

export const applyPromoCode = createAction(
  '[ApplyPromoCode] Apply',
  props<{ promoCode: string; options?: { silent?: boolean } }>(),
);

export const applyPromoCodeSuccess = createAction(
  '[ApplyPromoCode/API] Apply PromoCode Success',
  props<{
    payload: {
      promoCode: PromoCode | string;
      local?: boolean;
      silent?: boolean;
    };
  }>(),
);

export const applyPromoCodeFailure = createAction(
  '[ApplyPromoCode/API] Apply PromoCode Failure',
  props<{ error: Error; promoCode: string }>(),
);

//
// Actions for the promo code dialog
//
export const PromoCodeDialogAction = createActionGroup({
  source: '[PromoCode/Dialog]',
  events: {
    'Open Dialog': (promoCode?: string, options?: { source: string }) => ({
      promoCode,
      options,
    }),
    'Opened Dialog': (promoCode?: string, options?: { source: string }) => ({
      promoCode,
      options,
    }),
    'Close Dialog': emptyProps(),
  },
});

// refactor promo code loaded from local storage
export const AddPromoCodeToAuthUserAfterSignInAction = createActionGroup({
  source: '[AddPromoCodeToAuthUserAfterSignIn]',
  events: {
    // load promo code from local storage
    'Load Promo Code': emptyProps(),
    'Load Promo Code Failure': props<{ error: Error }>(),
    'Load Promo Code Success': props<{ promoCode: string }>(),

    // add promo code
    'Add Promo Code': props<{ promoCode: string }>(),
    'Add Promo Code Failure': props<{ promoCode: string; error: Error }>(),
    'Add Promo Code Success': props<{ promoCode: PromoCode }>(),
  },
});
